export default __webpack_public_path__ + "static/media/image_8.5e3e441d.jpg";